<template>
  <el-row>
    <el-upload
      drag
      action="#"
      :file-list="listFile"
      :auto-upload="false"
      :on-change="onFileChange"
      :on-remove="() => (listFile = [])"
      accept=".pdf"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        {{ $l('INDEX.file_upload_tips_first') || '将文件拖到此处，或' }}
        <em>{{ $l('INDEX.file_upload_tips_last') || '点击上传' }}</em>
      </div>
    </el-upload>
  </el-row>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: { fileType: { type: String, default: '' } },
  data() {
    return { listFile: [] }
  },
  methods: {
    onFileChange(file) {
      this.listFile = [file]
    },
    async upload() {
      if (!this.listFile || !this.listFile.length) {
        this.$message({
          message:
            this.$l('tips_warning_upload_file_empty') || '请选择需要上传的文件',
          type: 'warning',
        })
        return false
      }
      const { raw, name: originalFileName } = this.listFile[0]
      this.loadingOpen()
      const uploadRes = await this.$api.SYS_UPLOAD(raw).catch(() => null)
      const { status: uploadStatus, body } = uploadRes || {}
      if (200 !== uploadStatus) {
        this.$message.error(this.$l('tips_error_uploader_error') || '上传失败')
        this.loadingClose()
        return
      }
      const { fileId: fileMd5, url: fileUrl } = body
      const params = {
        fileMd5,
        fileUrl,
        originalFileName,
        fileType: this.fileType,
      }

      const res = await this.$api
        .ecomToolUploadFilesAddApi(params)
        .catch(() => null)
      const { status } = res || {}
      this.loadingClose()
      if (200 !== status) {
        this.$message.error(this.$l('tips_error_uploader_error') || '上传失败')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('tips_success_uploader_success') || '上传成功',
        type: 'success',
      })
      this.$emit('close')
      this.$emit('reload')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-upload,
  .el-upload-dragger {
    width: 100%;
  }
}
</style>
